import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
// import './ModalAlert.scss'
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";


interface IModalProps {
}


export const Modal: FunctionComponent<IModalProps> = observer<FunctionComponent<IModalProps>>(function () {

    const {translateStore} = useStorageTranslateContext();

    let open = translateStore.open



    return (
            <Dialog
                open={open}
                // onClose={() => translateStore.handleCloseNo()}
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        There are more untranslated records of this word. Do you want to translate the remaining words?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                       translateStore.confirmChange = false
                        translateStore.handleConfirmed(translateStore.confirmChange)
                        translateStore.handleClose()
                    }} color="error" >
                        No
                    </Button>
                    <Button onClick={() => {
                        translateStore.confirmChange = true
                        translateStore.handleConfirmed(translateStore.confirmChange)
                        translateStore.handleClose()
                    }}
                            color="primary" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
    );
});
